<div class="content-size">
    <ng-content />
</div>
